import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { FormField } from '@cp/ds/src/components/form';
import { useWatch } from 'react-hook-form';
import { KidIcon } from '@cp/ds/src/icons';
import { Typography } from '@cp/ds/src/components/typography';
import { TariffsEditFormModel } from '../model';
import { TariffsProps } from './model';

export const Tariffs: React.FC<TariffsProps> = ({ form, isSeparatedByChildrenCount }) => {
  // Reason to use 'useWatch' and 'getValues' together:
  // https://github.com/react-hook-form/react-hook-form/issues/2738
  useWatch<TariffsEditFormModel, 'tariffs'>({ name: 'tariffs' });
  const tariffs = form.getValues('tariffs') ?? [];

  const renderField = ({ childrenCount, index }: { childrenCount?: number; index?: number } = {}) => {
    return (
      <FormField
        endAdornment={
          typeof childrenCount !== 'undefined' && (
            <Typography sx={{ color: 'gray', display: 'inline-flex', alignItems: 'center' }} variant="caption bold">
              {childrenCount}x
              <KidIcon sx={{ ml: 0.5 }} />
            </Typography>
          )
        }
        fieldContainerProps={{ sx: { width: typeof childrenCount !== 'undefined' ? 1 : 415, maxWidth: 1 } }}
        fieldLabel="Оплата в час, рублей"
        htmlType="number"
        inputMode="numeric"
        key={childrenCount}
        name={typeof childrenCount !== 'undefined' ? `tariffs.${index}.price` : 'price'}
        placeholder="Укажите сумму в рублях"
        sx={{ width: 1 }}
        transform={{
          in: (v) => {
            const parsed = parseInt(String(v));
            if (Number.isNaN(parsed)) {
              return undefined;
            } else {
              return parsed;
            }
          },
          out: (v) => {
            if (v === undefined) {
              return v;
            }
            return String(v);
          },
        }}
        type="text"
      />
    );
  };

  return (
    <Stack gap={2} sx={{ mt: 2, width: 1 }}>
      {isSeparatedByChildrenCount
        ? tariffs.map(({ childrenCount }, index) => {
            return renderField({ childrenCount, index });
          })
        : renderField()}
    </Stack>
  );
};
